import colors from "../colors.js";

export default colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale-chromatic/src/categorical/Set2.js
// module id = ./node_modules/d3-scale-chromatic/src/categorical/Set2.js
// module chunks = 53